export default  {
        "pageName": "002",
        "pageId": 23,
        "whetherShow": "NO",
        "platformVos": [
            {
                "platform": "PC",
                "module1": [
                    {
                        "id": 309,
                        "moduleTypeId": 1,
                        "button1Text": "按钮一设置pc-更新",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": "按钮二设置pc-更新",
                        "button2Url": "https://www.hycan.com.cn/usp-007.html",
                        "button3Text": "按钮三设置pc-更新",
                        "button3Url": "https://www.hycan.com.cn/usp-007.html",
                        "horizontalScreenBigPic": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }, {
                        "id": 309,
                        "moduleTypeId": 1,
                        "button1Text": "按钮一设置pc2-更新",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": "按钮二设置pc-2更新",
                        "button2Url": "https://www.hycan.com.cn/usp-007.html",
                        "button3Text": "按钮三设置pc2-更新",
                        "button3Url": "https://www.hycan.com.cn/usp-007.html",
                        "horizontalScreenBigPic": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "NO"
                    }
                ],
                "module2": [
                    {
                        "id": 310,
                        "moduleTypeId": 2,
                        "show": "true",
                        "video": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133131144-20210628102900908-ldtc.mp4"
                    }
                ],
                "module3": [
                    {
                        "id": 311,
                        "moduleTypeId": 3,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554410-web_usp_02@1x.jpg",
                        "bottomGroupPic": [
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133148198-20210623140554019-web_usp_0201%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133155759-20210623140550935-web_usp_0203%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133204541-20210623140554410-web_usp_02%401x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module4": [
                    {
                        "id": 312,
                        "moduleTypeId": 4,
                        "groupGif": [
                            'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628102900908-ldtc.mp4',
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103055329-smtc.mp4",
                        'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103033752-pljs.mp4'
                        ],
                        "topicTitle": "顶部标题pc",
                        "bottomDes": "底部简介pc",
                        "backgroundColorValue": "#50e3c2",
                        "show": "true"
                    }
                ],
                "module5": [
                    {
                        "id": 313,
                        "moduleTypeId": 5,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623165851177-web_usp_04@1x.jpg",
                        "sidePic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623170130709-web_usp_0402@2x.png",
                        "show": "true"
                    }
                ],
                "module6": [
                    {
                        "id": 314,
                        "moduleTypeId": 6,
                        "gif": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }
                ],
                "module7": [
                    {
                        "id": 315,
                        "moduleTypeId": 7,
                        "pic1": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0601@1x.jpg",
                        "picText1": "组图文案pc1",
                        "picDes1": "组图描述pc1",
                        "pic2": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163754465-web_usp_0602@1x.jpg",
                        "picText2": "组图文案pc2",
                        "picDes2": "组图描述pc2",
                        "pic3": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0603@1x.jpg",
                        "picText3": "组图文案pc3",
                        "picDes3": "组图描述pc3",
                        "show": "true"
                    }
                ],
                "module8": [
                    {
                        "id": 316,
                        "moduleTypeId": 8,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007472-pc+_%3F%3F%3F%3F.png",
                        "show": "true"
                    }
                ],
                "module9": [
                    {
                        "id": 317,
                        "moduleTypeId": 9,
                        "videoLeft": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630095627%2F75fe7aac4d3f40ff916a513dd5fb1d78.mp4",
                        "videoLeftTitle": "视频左标题",
                        "videoLeftDes": "视频左描述",
                        "videoRight": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630100548%2F5ad1f3140938430db214782e4f703764.mp4",
                        "videoRightTitle": "视频右标题",
                        "videoRightDes": "视频右描述",
                        "show": "true"
                    }
                ],
                "module10": [
                    {
                        "id": 318,
                        "moduleTypeId": 10,
                        "style": "leftLarge",
                        "topicTitle": "220V对外放电",
                        "topicDes": "随时随地，看一场户外电影，或与家人朋友露营BBQ，对外放电功能解锁出游无限可能",
                        "jiugonggeGroupPic": [
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134528179-web_usp_0901@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527619-web_usp_0902@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134530394-web_usp_0903@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527596-web_usp_0904@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527984-web_usp_0906@1x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module11": [
                    {
                        "id": 319,
                        "moduleTypeId": 11,
                        "button1Text": "预约试驾",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": null,
                        "button2Url": null,
                        "bottomBigPic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20211021163005483-2.jpg",
                        "show": "true"
                    }
                ]
            },
            {
                "platform": "IPAD",
                "module1": [
                    {
                        "id": 309,
                        "moduleTypeId": 1,
                        "button1Text": "",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": "按钮二设置pc-更新",
                        "button2Url": "https://www.hycan.com.cn/usp-007.html",
                        "button3Text": "按钮三设置pc-更新",
                        "button3Url": "https://www.hycan.com.cn/usp-007.html",
                        "horizontalScreenBigPic": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }
                ],
                "module2": [
                    {
                        "id": 310,
                        "moduleTypeId": 2,
                        "show": "true",
                        "video": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133131144-20210628102900908-ldtc.mp4"
                    }
                ],
                "module3": [
                    {
                        "id": 311,
                        "moduleTypeId": 3,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554410-web_usp_02@1x.jpg",
                        "bottomGroupPic": [
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133148198-20210623140554019-web_usp_0201%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133155759-20210623140550935-web_usp_0203%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133204541-20210623140554410-web_usp_02%401x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module4": [
                    {
                        "id": 312,
                        "moduleTypeId": 4,
                        "groupGif": [
                            'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628102900908-ldtc.mp4',
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103055329-smtc.mp4",
                        'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103033752-pljs.mp4'
                        ],
                        "topicTitle": "顶部标题pc",
                        "bottomDes": "底部简介pc",
                        "backgroundColorValue": "#50e3c2",
                        "show": "true"
                    }
                ],
                "module5": [
                    {
                        "id": 313,
                        "moduleTypeId": 5,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649117-pad_usp_04@2x.jpg",
                        "sidePic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623170130709-web_usp_0402@2x.png",
                        "show": "true"
                    }
                ],
                "module6": [
                    {
                        "id": 314,
                        "moduleTypeId": 6,
                        "gif": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }
                ],
                "module7": [
                    {
                        "id": 315,
                        "moduleTypeId": 7,
                        "pic1": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0601@1x.jpg",
                        "picText1": "组图文案pc1",
                        "picDes1": "组图描述pc1",
                        "pic2": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163754465-web_usp_0602@1x.jpg",
                        "picText2": "组图文案pc2",
                        "picDes2": "组图描述pc2",
                        "pic3": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629163751813-web_usp_0603@1x.jpg",
                        "picText3": "组图文案pc3",
                        "picDes3": "组图描述pc3",
                        "show": "true"
                    }
                ],
                "module8": [
                    {
                        "id": 316,
                        "moduleTypeId": 8,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007472-pc+_%3F%3F%3F%3F.png",
                        "show": "true"
                    }
                ],
                "module9": [
                    {
                        "id": 317,
                        "moduleTypeId": 9,
                        "videoLeft": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630095627%2F75fe7aac4d3f40ff916a513dd5fb1d78.mp4",
                        "videoLeftTitle": "视频左标题",
                        "videoLeftDes": "视频左描述",
                        "videoRight": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630100548%2F5ad1f3140938430db214782e4f703764.mp4",
                        "videoRightTitle": "视频右标题",
                        "videoRightDes": "视频右描述",
                        "show": "true"
                    }
                ],
                "module10": [
                    {
                        "id": 318,
                        "moduleTypeId": 10,
                        "style": "leftLarge",
                        "topicTitle": "220V对外放电",
                        "topicDes": "随时随地，看一场户外电影，或与家人朋友露营BBQ，对外放电功能解锁出游无限可能",
                        "jiugonggeGroupPic": [
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134528179-web_usp_0901@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527619-web_usp_0902@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134530394-web_usp_0903@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527596-web_usp_0904@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527984-web_usp_0906@1x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module11": [
                    {
                        "id": 319,
                        "moduleTypeId": 11,
                        "button1Text": "预约试驾",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": null,
                        "button2Url": null,
                        "bottomBigPic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20211021163005483-2.jpg",
                        "show": "true"
                    }
                ]
            },
            {
                "platform": "IPHONE",
                "module1": [
                    {
                        "id": 309,
                        "moduleTypeId": 1,
                        "button1Text": "按钮一设置pc-更新",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": "按钮二设置pc-更新",
                        "button2Url": "https://www.hycan.com.cn/usp-007.html",
                        "button3Text": "按钮三设置pc-更新",
                        "button3Url": "https://www.hycan.com.cn/usp-007.html",
                        "horizontalScreenBigPic": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }
                ],
                "module2": [
                    {
                        "id": 310,
                        "moduleTypeId": 2,
                        "show": "true",
                        "video": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133131144-20210628102900908-ldtc.mp4"
                    }
                ],
                "module3": [
                    {
                        "id": 311,
                        "moduleTypeId": 3,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554410-web_usp_02@1x.jpg",
                        "bottomGroupPic": [
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133148198-20210623140554019-web_usp_0201%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133155759-20210623140550935-web_usp_0203%402x.png",
                            "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133204541-20210623140554410-web_usp_02%401x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module4": [
                    {
                        "id": 312,
                        "moduleTypeId": 4,
                        "groupGif": [
                            'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628102900908-ldtc.mp4',
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103055329-smtc.mp4",
                        'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628103033752-pljs.mp4'
                        ],
                        "topicTitle": "顶部标题pc",
                        "bottomDes": "底部简介pc",
                        "backgroundColorValue": "#50e3c2",
                        "show": "true"
                    }
                ],
                "module5": [
                    {
                        "id": 313,
                        "moduleTypeId": 5,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624160649405-phone_usp_04@3x.jpg",
                        "sidePic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623170130709-web_usp_0402@2x.png",
                        "show": "true"
                    }
                ],
                "module6": [
                    {
                        "id": 314,
                        "moduleTypeId": 6,
                        "gif": "https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20220818133118672-20210629163535234-web_usp_01%401x.jpg",
                        "show": "true"
                    }
                ],
                "module7": [
                    {
                        "id": 315,
                        "moduleTypeId": 7,
                        "pic1": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171106095-pad_usp_0601@2x.jpg",
                        "picText1": "组图文案pc1",
                        "picDes1": "组图描述pc1",
                        "pic2": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171105873-pad_usp_0602@2x.jpg",
                        "picText2": "组图文案pc2",
                        "picDes2": "组图描述pc2",
                        "pic3": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628171105876-pad_usp_0603@2x.jpg",
                        "picText3": "组图文案pc3",
                        "picDes3": "组图描述pc3",
                        "show": "true"
                    }
                ],
                "module8": [
                    {
                        "id": 316,
                        "moduleTypeId": 8,
                        "gif": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007472-pc+_%3F%3F%3F%3F.png",
                        "show": "true"
                    }
                ],
                "module9": [
                    {
                        "id": 317,
                        "moduleTypeId": 9,
                        "videoLeft": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630095627%2F75fe7aac4d3f40ff916a513dd5fb1d78.mp4",
                        "videoLeftTitle": "视频左标题",
                        "videoLeftDes": "视频左描述",
                        "videoRight": "https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630100548%2F5ad1f3140938430db214782e4f703764.mp4",
                        "videoRightTitle": "视频右标题",
                        "videoRightDes": "视频右描述",
                        "show": "true"
                    }
                ],
                "module10": [
                    {
                        "id": 318,
                        "moduleTypeId": 10,
                        "style": "leftLarge",
                        "topicTitle": "220V对外放电",
                        "topicDes": "随时随地，看一场户外电影，或与家人朋友露营BBQ，对外放电功能解锁出游无限可能",
                        "jiugonggeGroupPic": [
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134528179-web_usp_0901@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527619-web_usp_0902@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134530394-web_usp_0903@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527596-web_usp_0904@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg",
                            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527984-web_usp_0906@1x.jpg"
                        ],
                        "show": "true"
                    }
                ],
                "module11": [
                    {
                        "id": 319,
                        "moduleTypeId": 11,
                        "button1Text": "预约试驾",
                        "button1Url": "https://www.hycan.com.cn/usp-007.html",
                        "button2Text": null,
                        "button2Url": null,
                        "bottomBigPic": "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20211021163005483-2.jpg",
                        "show": "true"
                    }
                ]
            }
        ]
   
}